
import { AdminState } from '@/types/adminTypes';
import { STATE_CACHE_TTL, createDefaultState } from './adminStateConfig';

// In-memory cache
let stateCache: AdminState | null = null;
let lastStateFetch = 0;

/**
 * Get the current state from cache if valid, or return null
 */
export const getStateFromCache = (): AdminState | null => {
  const now = Date.now();
  
  if (stateCache && (now - lastStateFetch < STATE_CACHE_TTL)) {
    return stateCache;
  }
  
  return null;
};

/**
 * Update the cache with a new state
 */
export const updateStateCache = (state: AdminState): void => {
  stateCache = state;
  lastStateFetch = Date.now();
};

/**
 * Get current cached state or default state
 */
export const getCachedStateOrDefault = (): AdminState => {
  return stateCache || createDefaultState();
};

/**
 * Clear the cache
 */
export const clearStateCache = (): void => {
  stateCache = null;
};
